import React from "react";
import styles from "./assign.module.scss";

export const BranchDropdown = ({ branch, index, addBranchIndex, addBranchValue, options, dropRef }) => {
  if (!branch || index !== addBranchIndex) return null;

  return (
    <div className={`dropdown-menu ${styles.dropdown_align_add} show`} ref={dropRef}>
      {options.map((option, i) => (
        <p key={i} className={styles.dropdown_heading_add} onClick={() => addBranchValue(option, index)}>
          {option}
        </p>
      ))}
    </div>
  );
};
